function PresentationConfection() {
    return (
        <div className={"explication-confection"}>
            <h1>La confection sur mesure: mon activité principal</h1>
            <div>Que se soit des robes de marié au costume homme en passant par les sous-vêtements, je réalise
                chacune de vos demandes pour un vêtement qui vous correspon.
            </div>
        </div>
    )
}

export default PresentationConfection